module.exports = __webpack_public_path__ + "src/components/icon-exclamation.1efbfb3694cc8ea2da2ffe4682d1e943.svg";